import { Button, Grid2 } from '@mui/material';
import { Field, Formik, Form } from 'formik';
import * as yup from "yup";
import UtItem from '../../shared/utils/UtList';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import useAuthStore from '../../store/useAuthStore';
import { useToaster } from '../../shared/utils/ToasterProvider';
import { Grid_Gap, Input_Width } from '../../shared/constants';
import { IdAutoCompleteField } from '../../shared/components/formfields/IdAutoCompleteField';
import { useAllUserList, useGetAllClusters } from '../../assets/api/useAdminApi';
import api from '../../assets/nodeApi/axiosInstance';
import CustomDivider from '../../shared/utils/CustomDivider';

const AssignClustertoCoordinator = () => {
   
    const queryClient = useQueryClient();
    const { showToaster } = useToaster();
    const { token } = useAuthStore()
    const [selectedCluster, setSelectedCluster] = useState([])
    const { data: allUserList, isLoading: isUserloading } = useAllUserList({ role: "coordinator" })

    const CoordinatorOption = allUserList?.data?.map((item, index) => ({
        id: item?.id || index + 1,
        value: item?.firstname,
        label: item?.firstname
    })) || [];

    const { data: ClusterList, isLoading: isLoadingClusterList } = useGetAllClusters()

    const ClusterOption = ClusterList?.map((item) => ({
        id: item?.id,
        value: item?.cluster_name,
        label: item?.cluster_name
    })) || [];

    const handleRemove = (id) => {
        setSelectedCluster(prev => prev.filter(apartment => apartment.id !== id));
    };

    const mutationAssign = useMutation({
        mutationFn: (formData) => {
            return api.put(`users/assign-reassign-cluster`, formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
        },
        onSuccess: (response) => {
            showToaster('Success', response?.data?.message, 'success')
            queryClient.invalidateQueries({ queryKey: ['clusters/by-coordinator'] });
            setSelectedCluster([])
        },
        onError: () => {
            showToaster("Error Caught While submiting the form", 'Error', 'error');
        },
    });

    const handleAssign = (values, { setSubmitting, resetForm }) => {
        if (selectedCluster.length === 0) {
            showToaster('Add Atleast one Cluster', "Warning", 'warning');
            return;
        }
        const obj = {
            user_id: values?.user_id,
            cluster_ids: selectedCluster.map(apartment => apartment.id)
        }
        mutationAssign.mutate(obj, {
            onSettled: () => {
                setSubmitting(false);
            },
            onSuccess: () => {
                resetForm();
            }
        });
    }

    return (

        <Formik
            initialValues={{ user_id: "" }}
            validationSchema={yup.object().shape({
                user_id: yup.string().required("Coordinator is required"),
            })}
            onSubmit={handleAssign}
        >
            {({ resetForm, setFieldValue }) => (
                <Form>
                    <Grid2 container spacing={Grid_Gap}>
                        <Grid2 children size={12}>
                            {selectedCluster?.map((item, index) => (
                                <UtItem key={index} text={item?.label} onRemove={() => { handleRemove(item?.id) }} />
                            ))}
                        </Grid2>
                        <Grid2 children size={Input_Width}>
                            <Field
                                name="user_id"
                                component={IdAutoCompleteField}
                                options={CoordinatorOption}
                                label="Select Coordinator"
                                isRequired={true}
                                isLoading={isUserloading}

                            />
                        </Grid2>
                        <Grid2 children size={Input_Width}>
                            <Field
                                name="cluster_ids"
                                component={IdAutoCompleteField}
                                options={ClusterOption}
                                label="Select Cluster"
                                isRequired={true}
                                isLoading={isLoadingClusterList}
                                onValueChange={(newValue) => {
                                    setSelectedCluster((prev) => {
                                        const exists = prev.find((item) => item.id === newValue.id);
                                        return exists ? prev : [...prev, newValue];
                                    });
                                    setFieldValue("cluster_ids", "")
                                }}

                            />
                        </Grid2>
                    </Grid2>
                    <CustomDivider />
                    <Grid2 container spacing={Grid_Gap} sx={{ display: "flex", justifyContent: "end" }}>
                        <Grid2 children size={{ xs: 12, sm: 3 }}>
                            <Button variant='outlined' fullWidth onClick={() => { resetForm(); setSelectedCluster() }}>Cancel</Button>
                        </Grid2>
                        <Grid2 children size={{ xs: 12, sm: 3 }}>
                            <Button variant='contained' type="submit" fullWidth>Submit</Button>
                        </Grid2>
                    </Grid2>
                </Form>
            )}
        </Formik>

    )
}

export default AssignClustertoCoordinator